
import * as moment from 'moment';

export default class Utils {
  static getPathParam(url: string, param: string): number {
    if (url) {
      const indexOfParamInPath = url.indexOf(param);
      return +url.substring(indexOfParamInPath + param.length + 1,
        url.substring(indexOfParamInPath + param.length + 1).indexOf('/'));
    }
  }

  static getMonths(fromDate, tillDate) {
    let months = 0;
    const startDate = moment(fromDate, 'YYYY-MM-DD');
    const endDate = moment(tillDate, 'YYYY-MM-DD');
    months = endDate.diff(startDate, 'months');
    const isStartDateStartOfTheMonth = (startDate.date() === 1) ? true : false;
    const isEndDateLastDateOfTheMonth = (endDate.daysInMonth() === endDate.date()) ? true : false;
    months += ((isStartDateStartOfTheMonth && isEndDateLastDateOfTheMonth) ? 1 : 0);
    return Math.abs(months);
  }

  static capitalizeFn(s: string): string {
    return (s && `${s[0]}`.toUpperCase() + `${s}`.slice(1)) || '';
  }

  static isObject(variable: any): boolean {
    return variable !== null && typeof variable === 'object' && !Array.isArray(variable);
  }
}
